export default "__VITE_ASSET__B6ur5Z5b__"